import React from 'react';
import history from '../../../../services/history';
import { Button } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import PageMainHeader from '../../../common/pages/PageMainHeader/PageMainHeader.component';
import PageMainBody from '../../../common/pages/PageMainBody/PageMainBody.component';

import { Container } from './ChannelIndex.styles';
import { Illustration } from 'src/assets/illustratorElement/illustrators';

const ChannelIndex = () => {
  const channelIndexTitle = useGlotaT('spa.certification.channelIndexTitle');
  const channelIndexSubtitle = useGlotaT('spa.certification.channelIndexSubtitle');
  const channelIndexDescription = useGlotaT('spa.certification.channelIndexDescription');
  const channelIndexButton = useGlotaT('spa.certification.channelIndexButton');

  const goToChannelsList = () => {
    history.push({
      pathname: '/tools/channels/add',
    });
  };

  return (
    <>
      <PageMainHeader
        title={channelIndexTitle}
        icon="poli-icon pi-channels-line"
      ></PageMainHeader>
      <PageMainBody>
        <Container>
          <Illustration imgName="channelIndexImg" />
          <h2>{channelIndexSubtitle}</h2>
          <p>
            {channelIndexDescription}
          </p>
          <Button
            id="get-channels"
            gradient="primary"
            onClick={goToChannelsList}
          >
            {channelIndexButton}
          </Button>
        </Container>
      </PageMainBody>
    </>
  );
};

export default ChannelIndex;
